<template>
  <div>
      <br /><br /><br />
      <div class="container">
  <h5 class=" txtBlack text-center">
            {{ $t('optional-revenue-generator') }}
          </h5>
          <hr />
          <div class=" seasoncast-card p-3">
        <p>{{ $t('the-optional-viewer-payment-system-makes-it-easy-for-you-to-generate-income-for-your-booster-club-organization-team-sports-network-etc-all-you-have-to-do-is-set-up-the-payment-infomation-then-broadcast-like-normal-on-seasoncast') }}
<br /><br />
{{ $t('related-links') }}
<br />

<a href="https://seasoncast.com/broadcaster/revenue">{{ $t('go-to-revenue-in-dashboard') }}</a><br />
<a href="https://seasoncast.freshdesk.com/support/solutions/articles/61000277468-how-to-make-money-for-booster-club-team-organization-ect-">{{ $t('revenue-setup-guide') }}</a>

        </p>

    <div>

</div>


</div>
<br />
   <div class=" seasoncast-card" style="padding:0px">
          <div class="revenue_calc_header">

    <h3 class="p-2">{{ $t('estimated-revenue-calculator') }} </h3>
</div>
   <div class="p-3">
       <br />
       <p>{{ $t('how-many-viewers-during-the-entire-season') }} <b>{{ $t('in_viewers-viewers', [in_viewers]) }}</b></p>
         <input type="range" min="10" step="10" max="3000" value="350" class="slider" v-model="in_viewers" >
<br /><br />
        <p>{{ $t('how-much-will-you-charge-for-a-seasonpass-to-the-entire-season') }} <b >${{in_price}}</b></p>
         <input type="range" min="5" step="1" max="150" value="65" class="slider" v-model="in_price" >
<br />
<hr />
<br />
<h2 style="text-align:center; width:100%">{{ $t('your-total-revenue') }} <b>{{net_income - fees | currency}}</b></h2>
    </div>
</div>
<br />
<br />

</div>

<br /><br />

</div>
</template>

<script>

export default {
     created: async function () {
   },
    data: function () {
    return {
      in_viewers: 400,
      in_price: 49.0
    }
  },
  computed: {
      net_income: function () {
          return this.in_viewers * this.in_price
      },
    fees: function () {
          return (this.net_income * 0.20 + (parseFloat(this.in_viewers) * 0.30))
      }
  },
  
}

</script>
<style scoped>
.revenue_calc_header{ 
    color:white; background-color: rgb(60, 60, 134); width:100%; padding:10px; text-align:center;
    border-top-left-radius:0.3rem;
    border-top-right-radius:0.3rem;
}

.slider {
  -webkit-appearance: none;  /* Override default CSS styles */
  appearance: none;
  width: 100%; /* Full-width */
  
  background: #d3d3d3; /* Grey background */
  outline: none; /* Remove outline */
  opacity: 0.7; /* Set transparency (for mouse-over effects on hover) */
  -webkit-transition: .2s; /* 0.2 seconds transition on hover */
  transition: opacity .2s;
}

/* Mouse-over effects */
.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 15px;
  border-radius: 5px;  
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: .2s;
  transition: opacity .2s;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  border-radius: 50%; 
  background: #242a4d;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #4CAF50;
  cursor: pointer;
}
</style>>